import React, { Component } from "react";
import Common from '../shared/common';
import { withRouter } from '../shared/hoc/withRouter';
import { FormattedMessage } from "react-intl";
import moment from 'moment';
import * as contractOtherPriceCrud from '../crud/contractOtherPrice.crud';
import { withSnackbar } from 'notistack';
import { injectIntl } from "react-intl";

const spanStyle = {
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  paddingBottom: 0
};

const spanStyleViewRegister = {
  whiteSpace: 'normal',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  paddingBottom: 0,
  fontWeight: 400
};

// Layout Styles
const styles = {
    scrollContainer: {
        display: 'flex',
        flexDirection: 'row',
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
        paddingBottom: '10px',
        scrollSnapType: 'x mandatory',
        msOverflowStyle: 'thin',
        scrollbarWidth: 'thin',
    },
    currencyCard: {
        flex: '0 0 33.333%',
        minWidth: '33.333%',
        padding: '0 20px',
        borderRight: '1px solid #ebedf2',
        scrollSnapAlign: 'start',
        boxSizing: 'border-box'
    }
};

function calculateChangeRate(numerator, denominator) {
  if ((denominator === 0 || denominator === null) && (numerator > 0)) {
    return '100%';
  } else if (numerator === null || numerator === 0 || denominator === null || denominator === 0) {
    return '0%';
  } else {
    const changeRate = (((numerator) + 0) / (denominator + 0)) * 100;
    return Common.FormatNum(changeRate) + '%'
  }
}

class MultipleContractPrice extends Component {
  state = {
    allCurrenciesData: [] 
  }

  componentDidMount() {
    this.refreshAllCurrencies();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.contract.currencyoptions) !== JSON.stringify(this.props.contract.currencyoptions)) {
      this.refreshAllCurrencies();
    }
  }

  refreshAllCurrencies = async () => {
    let currencyOptions = this.props.contract.currencyoptions || [];

    if (this.props.contract.contractid === 0) {
        currencyOptions = [
            { currency: 'GBP' }, 
            { currency: 'EUR' }, 
            { currency: 'USD' }
        ];
    }

    const dataPromises = currencyOptions.map(option => this.getCurrencyData(option.currency));
    const results = await Promise.all(dataPromises);
    this.setState({ allCurrenciesData: results.filter(r => r !== null) });
  }

  getCurrencyData = async (currencyCode) => {
    try {
      if (this.props.contract.contractid === 0) {

        return this.getCurrencyState(currencyCode, [], { 
            currency: currencyCode, 
            originalprice: 100000 
        });
      } else {
        const selectedCurrencyOption = this.props.contract.currencyoptions.find(opt => opt.currency === currencyCode);
        const { data: currencyChangeSummary } = await contractOtherPriceCrud.getContractOtherPriceChangeSummary(this.props.contract.contractid, selectedCurrencyOption.currency);
        return this.getCurrencyState(currencyCode, currencyChangeSummary, selectedCurrencyOption);
      }
    } catch (err) {
      this.props.enqueueSnackbar(err.toString(), { variant: 'error' });
      return null;
    }
  };

  getCurrencyState = (currencyCode, currencyChangeSummary, selectedSecondaryPrice) => {
    const priceChanges = [];
    let wf = null;
    const { workflowsQA, resources: globalResources } = this.props.contractTemplate;

    const cenGroupWorkflowIDs = [5, 6, 7, 37, 46, 40, 67, 75, 76, 84, 85];
    const allCenGroupChanges = currencyChangeSummary.filter(x => cenGroupWorkflowIDs.includes(x.workflowid));
    const allOtherChanges = currencyChangeSummary.filter(x => !cenGroupWorkflowIDs.includes(x.workflowid));

    priceChanges.push({
      type: "INITIAL_PRICE",
      label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.INITIAL_PRICE' }, { PRICE: globalResources.PRICE }),
      amount: selectedSecondaryPrice.originalprice,
    });

    if (currencyCode === this.props.contract.currency) {
      wf = workflowsQA[38];
      const wfChangeAmount = allOtherChanges.filter(x => x.workflowid === 38).reduce((total, item) => total + (item.changeamount || 0), 0);
      if (wf) priceChanges.push({ type: "PRICE_CHANGE", label: wf.groupTitle, amount: wfChangeAmount, link: wf.paths.defaultPath });

      wf = workflowsQA[72];
      if (wf) {
        const wfChangeAmount = allOtherChanges.filter(x => x.workflowid === 72).reduce((total, item) => total + (item.changeamount || 0), 0);
        priceChanges.push({ type: "PRICE_CHANGE", label: wf.groupTitle, amount: wfChangeAmount, link: wf.paths.defaultPath });
      }
    }

    if (priceChanges.length > 1) {
      let orderGroupAmountSum = priceChanges
        .filter(x => x.type === "PRICE_CHANGE" || x.type === "INITIAL_PRICE")
        .reduce((total, wfItem) => total + (wfItem.amount || 0), 0);
      priceChanges.push({ type: "SUM", label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.NEW_PRICE' }), amount: orderGroupAmountSum });
    }

    const masterCenRegisterWF = workflowsQA[13] || workflowsQA[12] || workflowsQA[11];
    wf = workflowsQA[7] || workflowsQA[5] || workflowsQA[6] || workflowsQA[37] || workflowsQA[40] || workflowsQA[67] || workflowsQA[75] || workflowsQA[76] || workflowsQA[46] || workflowsQA[84] || workflowsQA[85];
    if (wf) {
      const quoteChangeAmount = allCenGroupChanges.reduce((total, item) => total + (item.changeamount || 0), 0);
      priceChanges.push({ type: "PRICE_CHANGE", label: wf.groupTitle, amount: quoteChangeAmount, link: masterCenRegisterWF?.paths?.defaultPath });
    }

    wf = workflowsQA[8];
    if (wf && allOtherChanges.some(x => x.workflowid === 8)) {
        const wfChangeAmount = allOtherChanges.filter(x => x.workflowid === 8).reduce((total, item) => total + (item.changeamount || 0), 0);
        priceChanges.push({ type: "PRICE_CHANGE", label: wf.title, amount: wfChangeAmount, link: wf.paths.defaultPath });
    }

    if (currencyCode === this.props.contract.currency) {
      //Price Assessment WF
      wf = workflowsQA[51];
      if (wf) {
        const wfChangeAmount = allOtherChanges.filter(x => x.workflowid === 51).reduce((total, item) => total + (item.changeamount ? item.changeamount : 0), 0);
        priceChanges.push({ type: "PRICE_CHANGE", label: wf.title, amount: wfChangeAmount, link: wf.paths.defaultPath });
      }
    }

    wf = workflowsQA[19];
    if (wf) {
      const wfChangeAmount = allOtherChanges.filter(x => x.workflowid === 19).reduce((total, item) => total + (item.changeamount ? item.changeamount : 0), 0);
      priceChanges.push({ type: "PRICE_CHANGE", label: wf.title, amount: wfChangeAmount, link: wf.paths.defaultPath });
    }

    wf = workflowsQA[77];
    if (wf) {
      const wfChangeAmount = allOtherChanges.filter(x => x.workflowid === 77).reduce((total, item) => total + (item.changeamount ? item.changeamount : 0), 0);
      priceChanges.push({ type: "PRICE_CHANGE", label: wf.title, amount: wfChangeAmount, link: wf.paths.defaultPath });
    }

    // let currentPriceSum = priceChanges
    //     .filter(x => x.type === "PRICE_CHANGE" || x.type === "INITIAL_PRICE")
    //     .reduce((total, wfItem) => total + (wfItem.amount || 0), 0);
    
    // priceChanges.push({
    //     type: "SUM",
    //     label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.CURRENT_PRICE' }, { PRICE: globalResources.PRICE }),
    //     amount: currentPriceSum,
    // });

    // let allPriceChanges = priceChanges
    //     .filter(x => x.type === "PRICE_CHANGE")
    //     .reduce((total, wfItem) => total + (wfItem.amount || 0), 0);

    // priceChanges.push({
    //     type: "CHANGE_RATE",
    //     label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.CHANGE_RATE' }),
    //     text: calculateChangeRate(allPriceChanges, currentPriceSum),
    // });

    let currentPriceSum = 0;
    
    if (priceChanges.length > 0) {
      currentPriceSum = priceChanges
        .filter(x => x.type === "PRICE_CHANGE" || x.type === "INITIAL_PRICE")
        .reduce((total, wfItem) => total + (wfItem.amount ? wfItem.amount : 0), 0);
      priceChanges.push({
        type: "SUM",
        label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.CURRENT_PRICE' }, { PRICE: globalResources.PRICE }),
        amount: currentPriceSum,
      });
    }

    ///Price Change Section
    if (priceChanges.length > 0) {
      let allPriceChanges = priceChanges
        .filter(x => x.type === "PRICE_CHANGE")
        .reduce((total, wfItem) => total + (wfItem.amount ? wfItem.amount : 0), 0);
      priceChanges.push({
        type: "PRICE_CHANGE_SUM",
        label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.PRICE_CHANGE' }, { PRICE: globalResources.PRICE }),
        amount: allPriceChanges,
      });

      priceChanges.push({
        type: "CHANGE_RATE",
        label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.CHANGE_RATE' }),
        text: calculateChangeRate(allPriceChanges, currentPriceSum),
      });
    }

    if (currencyCode === this.props.contract.currency) {
      ///Additional Forecast INFO
      wf = workflowsQA[52] || workflowsQA[53];
      if (wf) {
        priceChanges.push({
          type: "FORECAST_INFO",
          label: this.props.intl.formatMessage({ id: 'CONTRACT.DASHBOARD.FORECASTCOSTTOCOMPLETE' }),
          text: this.props.contractDashboard?.forecastcost ? Common.FormatCurrencyNum(this.props.contractDashboard.forecastcost, this.props.contract.currency) : '-',
          text2: this.props.contractDashboard?.forecastdate ? moment(this.props.contractDashboard.forecastdate).format('L').replace(/\//g, '.') : '-'
        });
      }
    }

    return { currencyCode, priceChanges };
  }

  render() {
    const { resources: globalResources } = this.props.contractTemplate;
    const { allCurrenciesData } = this.state;

    if (!allCurrenciesData || allCurrenciesData.length === 0) return null;

    const link = "/contract/" + this.props.contract.contractid + "/settings/secondary-prices";

    // 0. SORT DATA BY priceChanges COUNT
    // Descending order (Currency with most rows first)
    const sortedCurrencies = [...allCurrenciesData].sort((a, b) => 
        (b.priceChanges ? b.priceChanges.length : 0) - (a.priceChanges ? a.priceChanges.length : 0)
    );

    // 1. MASTER ROW LIST (Unique labels)
    // Using sortedCurrencies ensures the master list is built efficiently
    const masterRows = [];
    sortedCurrencies.forEach(currencyGroup => {
        currencyGroup.priceChanges.forEach(item => {
            const exists = masterRows.find(r => r.label === item.label && r.type === item.type);
            if (!exists) {
                masterRows.push({ label: item.label, type: item.type, link: item.link });
            }
        });
    });

    return (
      <div className="kt-widget14" style={{ width: '100%' }}>
        {/* MAIN HEADER: Original design */}
        <div className="kt-widget14__header" style={{ marginBottom: '20px' }}>
          <h3 className="kt-widget14__title">
            {this.props.title ? this.props.title : (
              <FormattedMessage id={"CONTRACT.DASHBOARD.CONTRACT_PRICE"} values={{ PRICE: globalResources.PRICE }} />
            )}
          </h3>
        </div>

        <div style={{ overflowX: 'auto' }} className="custom-horizontal-scroll">
          <div className="kt-widget12" style={{ minWidth: `${300 + (sortedCurrencies.length * 160)}px` }}>
            
            {/* COLUMN HEADERS: Displaying currency codes using the title style */}
            <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px', borderBottom: '1px solid #ebedf2', marginBottom: '15px' }}>
              <div style={{ flex: '0 0 300px' }}></div> 
              {sortedCurrencies.map((group, index) => (
                <div 
                  key={group.currencyCode} 
                  style={{ 
                    flex: '1', 
                    textAlign: 'center', 
                    paddingRight: '15px',
                    // VERTICAL SEPARATOR: Applied to all columns except the first one
                    //borderLeft: index > 0 ? '1px solid #ebedf2' : 'none' 
                    borderLeft: '1px solid #ebedf2'
                  }}
                >
                  <span className="kt-widget14__title" style={{ fontSize: '1.1rem', fontWeight: '500' }}>
                    {group.currencyCode}
                  </span>
                </div>
              ))}
            </div>

            {/* ROWS AND DATA */}
            <div className="kt-widget12__content">
              {masterRows.map((row, idx) => {
                if (row.type === "SEPERATOR") {
                  return <div key={`sep-${idx}`} className="contractPriceSeperator" style={{ margin: '15px 0' }} />;
                }

                return (
                  <div 
                    key={`row-${idx}`} 
                    className={"kt-widget12__item" + (row.type === "SUM" ? " kt-widget12__summary" : "")} 
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '0.8rem' }}
                  >
                    {/* LEFT SIDE: Label (Rendered only once per row) */}
                    <div className="kt-widget12__info" style={{ flex: '0 0 300px' }}>
                      <span className="kt-widget12__desc" style={spanStyle}>
                        {row.label}
                      </span>
                    </div>

                    {/* RIGHT SIDE: Corresponding values for each currency */}
                    {sortedCurrencies.map((currencyGroup, cIdx) => {
                      const itemMatch = currencyGroup.priceChanges.find(pc => pc.label === row.label && pc.type === row.type);

                      return (
                        <div 
                          key={`${currencyGroup.currencyCode}-${idx}`} 
                          className="kt-widget12__info" 
                          style={{ 
                            flex: '1', 
                            display: 'flex', 
                            alignItems: 'center',
                            paddingRight: '15px',
                            // VERTICAL SEPARATOR: Applied to all currency columns except the first one
                            //borderLeft: cIdx > 0 ? '1px solid #ebedf2' : 'none',
                            borderLeft: '1px solid #ebedf2',
                            minHeight: '40px' // Ensures consistent separator height across rows
                          }}
                        >
                          {itemMatch ? (
                            <>
                              {/* COLUMN 1: AMOUNT OR TEXT (Flexible area) */}
                              <div style={{ flex: 1, textAlign: 'right' }}>
                                {itemMatch.hasOwnProperty("amount") && (
                                  <span className="kt-widget12__value" style={{ ...spanStyle, fontWeight: 'normal' }}>
                                    {Common.FormatCurrencyNum(itemMatch.amount, currencyGroup.currencyCode)}
                                  </span>
                                )}
                                {itemMatch.hasOwnProperty("text") && (
                                  <span className="kt-widget12__value" style={spanStyle}>{itemMatch.text}</span>
                                )}
                              </div>

                              {/* COLUMN 2: LINK (Fixed width to maintain vertical alignment) */}
                              <div style={{ width: '80px', textAlign: 'right', marginLeft: '10px' }}>
                                {itemMatch.hasOwnProperty("link") ? (
                                  <span style={spanStyleViewRegister}>
                                    <a onClick={() => this.props.navigate(link)} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                      <FormattedMessage id="CONTRACT.DASHBOARD.VIEW" />
                                    </a>
                                  </span>
                                ) : (
                                  <div style={{ height: '1px' }}></div>
                                )}
                              </div>
                            </>
                          ) : (
                            <div style={{ flex: 1, textAlign: 'right', paddingRight: '80px' }}>
                              <span>-</span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(withSnackbar(withRouter(MultipleContractPrice)));